import { combineReducers } from 'redux';

import { authentication } from './authentication.reducer';
import { registration } from './registration.reducer';
import { users } from './users.reducer';
import { alert } from './alert.reducer';
import { customers } from './customer.reducer';
import { documents } from './document.reducer';
import { notifications } from './notification.reducer';

const rootReducer = combineReducers({
  authentication,
  registration,
  users,
  customers,
  alert,
  documents,
  notifications
});

export default rootReducer;